import { booleanAttribute, ChangeDetectionStrategy, Component, input } from '@angular/core';
import { InputFieldBaseComponent } from './input-field-base.component';
import { MatError, MatFormField, MatLabel, MatPrefix, MatSuffix } from '@angular/material/form-field';
import { NgStyle } from '@angular/common';
import { ExtendedModule } from '@ngbracket/ngx-layout/extended';
import { MatInput } from '@angular/material/input';
import { ReactiveFormsModule } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'mng-inputfield-password',
  imports: [
    MatFormField,
    MatLabel,
    MatPrefix,
    NgStyle,
    ExtendedModule,
    MatSuffix,
    MatInput,
    ReactiveFormsModule,
    MatIcon,
    MatError
  ],
  template: `
    <mat-form-field
      style="width: 100%; {{ inputTextStyle() }}"
      [ngStyle]="ngStyle()"
      [attr.id]="field().id"
      [appearance]="appearance()"
      [subscriptSizing]="subscriptSizing()"
      [floatLabel]="floatLabel()"
    >
      @if (field().label) {
        <mat-label>{{ field().label }}</mat-label>
      }
      <input
        [id]="field().id"
        [type]="hide ? 'password' : 'text'"
        matInput
        [formControl]="field().control"
        autocomplete="off"
        (keyup)="onKeyEvent($event)"
      />

      @if (iconName()) {
        <mat-icon matIconPrefix [svgIcon]="iconName()" style="height: 20px;" />
      }

      @if (hasErrors) {
        <mat-error> {{ validationMessage }} </mat-error>
      }

      @if (withShowPassword()) {
        <mat-icon
          matIconSuffix
          (click)="hide = !hide"
          [svgIcon]="hide ? 'eye-off-outline' : 'eye-outline'"
          style="height: 20px;"
        />
      }
      <!-- {{field().formControl.errors | json}} -->
    </mat-form-field>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InputFieldPasswordComponent extends InputFieldBaseComponent {
  hide = true;

  readonly withShowPassword = input(true, { transform: booleanAttribute });
}
